export default function StoryItemLoader(){
  return(
    <div className='animated-background w-100 h-100'>
      <div className="background-masker btn-divide-left">
      </div>
    </div>
  );
}